import { toNumberString, toPercent } from '@client/toolkit';

/** Em-dash placeholder shown for missing values across the portfolio reports. */
export const PLACEHOLDER = '\u2013';

export function formatNumber(value: number | null | undefined, fractionDigits = 0): string {
  if (value == null || Number.isNaN(value)) return PLACEHOLDER;
  return toNumberString(value, PLACEHOLDER, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatPercent(value: number | null | undefined, fractionDigits = 1): string {
  if (value == null || Number.isNaN(value)) return PLACEHOLDER;
  // Values arrive as percentages (e.g. 75 for 75%); toPercent expects a fraction.
  return toPercent(value / 100, PLACEHOLDER, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}
